// extracted by mini-css-extract-plugin
export default {"dataSelector":"DataSelector_dataSelector__Ld-ud","dropBox":"DataSelector_dropBox__k1d6+","dropItem":"DataSelector_dropItem__CmdmV"};